export const REAPPROVE_MEMBER_REQUEST_START =
  'REAPPROVE_MEMBER_REQUEST_START';
export const REAPPROVE_MEMBER_REQUEST_SUCCESS =
  'REAPPROVE_MEMBER_REQUEST_SUCCESS';
export const REAPPROVE_MEMBER_REQUEST_ERROR =
  'REAPPROVE_MEMBER_REQUEST_ERROR';
export const REAPPROVE_MEMBER_REQUEST_END =
  'REAPPROVE_MEMBER_REQUEST_END';
